import { Link } from 'react-router'
import { LuArrowRight } from 'react-icons/lu'
import { ROUTES } from '@/constants/routes'
import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { textLink } from '@/components/ui/linkStyles'
import { kandakePortrait, kandakeHeadshot, kandakeOutdoors } from '@/assets/siteMedia'

export const BooksAuthor = () => (
  <section className="border-t border-base-200 bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionHeader
            title="Written from the heart"
            accent="of clinical practice"
            className="mb-6"
          />
          <Reveal>
            <div className="space-y-4 text-base leading-7 text-base-600">
              <p>
                Kandake Makonnen is a BSc (Hons) Medical Herbalist with over 20 years of specialist
                clinical experience in women's health. The Cycle of Womanhood draws directly on her
                clinical practice, her studies with traditional healers across Africa and the
                Caribbean, and her own lived experience as a woman.
              </p>
              <p>
                This is not a generic wellness book. It is a clinical, cultural, and deeply personal
                work rooted in both indigenous healing wisdom and evidence-based phytotherapy.
              </p>
            </div>
            <Link to={ROUTES.ABOUT} className={`${textLink} mt-6`}>
              Read About Kandake
              <LuArrowRight aria-hidden="true" className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        <Reveal>
          <div className="grid grid-cols-2 gap-4">
            <SitePhoto
              src={kandakePortrait}
              alt="Kandake Makonnen, author and medical herbalist"
              aspect="aspect-[3/4]"
            />
            <div className="mt-8 flex flex-col gap-4">
              <SitePhoto src={kandakeHeadshot} alt="Kandake Makonnen" />
              <SitePhoto src={kandakeOutdoors} alt="Kandake studying plants in nature" />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
)
